export const SHOP_COUPON_UNITS = {
    AMOUNT: { value: "AMOUNT", text: "금액", suffix: "원" },
    PERCENT: { value: "PERCENT", text: "비율", suffix: "%", min: 0, max: 100 },
};
